import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "../assets/css/rate.css";
import rates from "../assets/data/rate.json";

const Rate = () => {
    const { t } = useTranslation();
    const skillsRef = useRef(null);

    useEffect(() => {
        if (!skillsRef.current) {
            return;
        }

        const element = skillsRef.current;
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        element.classList.add("visible");
                    } else {
                        element.classList.remove("visible");
                    }
                });
            },
            {
                threshold: 0.1,
            },
        );

        observer.observe(element);

        return () => {
            observer.unobserve(element);
            observer.disconnect();
        };
    }, []);

    return (
        <>
            <div className="rate" id="rate" ref={skillsRef}>
                <div className="head">
                    <h1>{t("rate.title")}</h1>
                    <h4>{t("rate.subtitle")}</h4>
                    <hr></hr>
                </div>

                {/* Read rate.json */}

                {rates.map(
                    (rate, index) =>
                        rate.display && (
                            <div
                                key={index}
                                className={`rate-cat ${rate.available ? "" : "unavailable"} ${rate.name}`}
                            >
                                <div>
                                    <h5>
                                        <b>{rate.name}</b>
                                        <br />
                                        {t(rate.descriptionKey)}
                                    </h5>
                                    <hr />
                                    <small>{t("rate.from")}</small>
                                    <br />
                                    {rate.reduce !== "" ?
                                        <>
                                            <span className="price">
                                                {rate.reduce}
                                            </span>
                                            <span className="no-price">
                                                {rate.price}
                                            </span>
                                        </>
                                    :   <>
                                            <span className="price">
                                                {rate.price}
                                            </span>
                                            <span className="info">
                                                {rate.info ? rate.info : ""}
                                            </span>
                                        </>
                                    }
                                    <hr />
                                </div>
                                <ul>
                                    {t(rate.featuresKey, {
                                        returnObjects: true,
                                    }).map((feature, idx) => (
                                        <li key={idx}>
                                            <i className="fa-duotone fa-solid fa-plus"></i>{" "}
                                            {feature}
                                        </li>
                                    ))}
                                </ul>
                                {!rate.available && (
                                    <small>
                                        <i className="fa-solid fa-circle-info"></i>{" "}
                                        {t("rate.unavailable")}
                                    </small>
                                )}
                            </div>
                        ),
                )}
            </div>
        </>
    );
};

export default Rate;
